import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Injectable({
	providedIn: 'root',
})
export class BottomPopupService {
	private readonly defaultSnackbarOptions: MatSnackBarConfig = {
		direction: 'rtl',
		panelClass: ['snackbar', 'snack-bar'],
		duration: 3000,
	};

	constructor(private snackbar: MatSnackBar) {}

	show(message: string, snackbarConfigs: { action?: string; options?: MatSnackBarConfig; forgetDefaultOptions?: boolean } = { action: 'סגור', options: {}, forgetDefaultOptions: false }): void {
		const action = snackbarConfigs.action ?? 'סגור';
		const options = snackbarConfigs.options ?? {};
		if (snackbarConfigs.forgetDefaultOptions) {
			this.snackbar.open(message, action, options);
			return;
		}
		this.snackbar.open(message, action, { ...this.defaultSnackbarOptions, ...options });
	}

	dismiss(): void {
		this.snackbar.dismiss();
	}
}
